export const onQuickSearch = payload => ({
    type: 'ON_QUICK_SEARCH',
    payload,
})
export const clearSearch = () => ({
    type: 'ON_CLEAR_SEARCH',
})
export const fromQuickSearch = (payload) => ({
    type: 'FROM_QUICK_SEARCH',
    payload,
})



// WEBPACK FOOTER //
// ./src/actions/quickSearchAction.js